<template>
  <j-modal
    title="所属信息"
    size="smaller"
    :visible="visible"
    :centered="false"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
    wrapClassName="a-modal-no-padding a-modal-fit-content"
  >
    <div class="div-relation-wrapper" v-if="relations.length > 0">
      <div
        class="div-relation"
        v-for="relation in relations"
        :key="relation.id"
        :class="[relation.mainFlag ? 'selected' : '', relation.positionName && relation.bizLineName ? 'shrink' : '']"
        @click="handleSelect(relation)"
      >
        <dt>
          <a-icon type="check" style="color: var(--color-primary)" v-if="relation.mainFlag" />
          <a-icon type="idcard" theme="twoTone" v-else />
        </dt>
        <dd>
          <span class="realname">
            <span>{{ relation.realname }}</span>
            <span v-if="relation.postLevel" style="zoom: 1; font-size: 12px; color: var(--color-purple)"
              >（{{ relation.postLevel }}）</span
            >
          </span>

          <span>
            <span class="iconify" data-icon="ci:dot-05-xl" data-inline="false" style="color: var(--color-blue)"></span>
            <span class="departName">{{ relation.departName }}</span>
          </span>

          <span v-if="relation.positionName">
            <span class="iconify" data-icon="ci:dot-05-xl" data-inline="false" style="color: var(--color-green)"></span>
            <span class="positionName">{{ relation.positionName }}</span>
          </span>

          <span v-if="relation.bizLineName">
            <span
              class="iconify"
              data-icon="ci:dot-05-xl"
              data-inline="false"
              style="color: var(--color-orange)"
            ></span>
            <span class="bizLineName">{{ relation.bizLineName }}</span>
          </span>
        </dd>
      </div>
    </div>
    <a-empty v-else style="margin: 24px"></a-empty>

    <template slot="footer">
      <a-button @click="handleCancel" type="primary" icon="close">关闭</a-button>
    </template>
  </j-modal>
</template>

<script>
import { getAction, postAction } from '@/api/manage'

export default {
  components: {},
  name: 'SelectRelation',
  data() {
    return {
      visible: false,
      loginUser: this.$getLoginUser(),
      relations: [],
      url: {
        selectRelation: '/EmployeeManage/selectRelation',
        getCurrentRelation: '/EmployeeTransferApply/getCurrentRelation',
      },
    }
  },
  created() {},
  methods: {
    handleOk() {
      var selected = XEUtils.first(XEUtils.filter(this.relations, (r) => r.mainFlag))

      if (!selected) {
        this.$message.warn('请选择一个主所属')
        return
      }

      postAction('/sys/selectRelation', { id: selected.id, userId: this.loginUser.id }).then((res) => {
        if (res.success) {
          this.$message.loading('切换成功，系统将重新加载，请稍等...')

          setTimeout(() => {
            location.reload()
          }, 500)
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleOpen() {
      this.visible = true

      getAction(this.url.getCurrentRelation, { userId: this.loginUser.id })
        .then((res) => {
          if (res.success) {
            this.relations = XEUtils.clone(res.result, true)
          }
        })
        .finally(() => {})
    },
    handleSelect(relation) {
      //this.relations.forEach((r) => {
      //  if (r.id == relation.id) {
      //    r.mainFlag = true
      //  } else {
      //    r.mainFlag = false
      //  }
      //})
    },
  },
}
</script>
<style lang="less" scoped>
.div-relation-wrapper {
  padding: 40px 16px 24px 40px;
  display: flex;
  flex-wrap: wrap;

  .div-relation {
  }
}
</style>
